import { useHardwareDetails } from "../../../../common/hooks/use-hardware-details";

const NO_PARENT = "-";

export interface CatalogItemImage {
  imageUrl: string | undefined;
  isLoading: boolean;
}

/** Orders reference the ordered version, which usually has no image; like checkout, fall back to its parent's. */
export const useCatalogItemImage = (taxonomyId: string | undefined): CatalogItemImage => {
  const { data: item, isLoading: isItemLoading } = useHardwareDetails(taxonomyId);
  const itemImage = item?.logoUrl?.trim() || undefined;
  const parentId =
    item && !itemImage && item.parentTaxonomyId && item.parentTaxonomyId !== NO_PARENT
      ? item.parentTaxonomyId
      : undefined;
  const { data: parent, isLoading: isParentLoading } = useHardwareDetails(parentId);

  return {
    imageUrl: itemImage ?? (parent?.logoUrl?.trim() || undefined),
    isLoading: isItemLoading || isParentLoading,
  };
};
